module.exports = __webpack_public_path__ + "media/img/home/gallery/gallery2-ed65189f933f9c2c59508a6a4e78b152.png";